// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import LocationService from 'services/LocationService';

// Components
import Loader from 'components/common/Loader';
import EditCountryModal from 'components/admin/countries/EditCountryModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';

//-------------------------------------------------------------------------------------------------------------------

class CountriesPage extends React.Component {

    constructor(props) {
        super(props);

        this.editCountryModalRef = React.createRef();

        this.state = {
            isLoading: true,
            filters: {}
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        const { filters } = this.state;
        GlobalStateService.setValues({
            area: 'countries'
        });
        const countries = await LocationService.listCountries(filters);
        this.setState({
            countries,
            isLoading: false
        });
    }

    async editCountry(country) {
        await this.editCountryModalRef.current.show({
            countryID: country.id
        });
        this.load();
    }

    async addCountry() {
        await this.editCountryModalRef.current.show({
        });
        this.load();
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({ filters }, () => this.load());
    }

    render() {
        return (<>
            <div className="page countries-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Countries</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addCountry()}>
                            <span className="fa-solid fa-plus"></span>{' '}
                            New country
                        </button>

                    </div>

                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} className="flex" />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditCountryModal ref={this.editCountryModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            countries
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable countries-table">
                    <thead>
                        <tr>
                            <th className="name-column">Name</th>
                            <th className="code-column">ISO Code</th>
                            <th className="geo-column">Geo</th>
                            <th className="default-currency-column">Currency</th>
                            <th className="num-instructors-column"># Instructors</th>
                        </tr>
                    </thead>
                    <tbody>
                        {countries.map(c =>
                            <tr key={c.id} onClick={e => this.editCountry(c)}>
                                <td>{c.name}</td>
                                <td>{c.isoCode2Chars}</td>
                                <td>{c.geoName}</td>
                                <td>{c.defaultCurrencyCode}</td>
                                <td>{c.numInstructors}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>
        );
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            filters
        } = this.state;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (<>

            <Form.Group className="">
                <Form.Label>Filters</Form.Label>
                <Form.Check
                    type="checkbox"
                    id="with-instructors"
                    checked={!!filters.withInstructors}
                    onChange={e => this.updateFilter('withInstructors', e.target.checked)}
                    label="Hide if no instructors"
                />
            </Form.Group>

        </>);
    }
}

export default withRouter(CountriesPage);